import { Link } from "react-router-dom";
import { Receipt, Coffee } from "lucide-react";
import { useApp } from "@/contexts/AppContext";

// ── Update this URL with your Buy Me a Coffee profile link ──
const BMAC_URL = "https://buymeacoffee.com/splitbill";

const Header = () => {
  const { language, setLanguage, currency, setCurrency } = useApp();

  return (
    <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-sm border-b border-zinc-200">
      <div className="max-w-4xl mx-auto px-4 h-14 flex items-center justify-between gap-3">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 text-zinc-900 hover:text-zinc-600 transition-colors shrink-0">
          <Receipt size={18} strokeWidth={1.5} />
          <span className="font-bold font-outfit tracking-tight">SplitBill</span>
        </Link>

        {/* Right side */}
        <div className="flex items-center gap-2">
          {/* Buy Me a Coffee */}
          <a
            href={BMAC_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="buy-me-coffee-btn"
            className="flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-full bg-amber-400 hover:bg-amber-500 text-amber-950 transition-all active:scale-95 shrink-0"
          >
            <Coffee size={12} strokeWidth={2} />
            <span className="hidden sm:inline">Traktir Kopi</span>
          </a>

          {/* Currency toggle */}
          <button
            data-testid="currency-toggle"
            onClick={() => setCurrency(currency === 'IDR' ? 'USD' : 'IDR')}
            className="text-xs font-semibold px-3 py-1.5 rounded-full border border-zinc-200 hover:bg-zinc-100 transition-all text-zinc-700"
          >
            {currency}
          </button>

          {/* Language toggle */}
          <button
            data-testid="language-toggle"
            onClick={() => setLanguage(language === 'id' ? 'en' : 'id')}
            className="text-xs font-semibold px-3 py-1.5 rounded-full border border-zinc-200 hover:bg-zinc-100 transition-all text-zinc-700"
          >
            {language.toUpperCase()}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
